import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AccountReducerAction, LCLranDashboardReducerAction, getFilterDropDown } from '../../../../store/actions/createTicketManageFields'
import { mopDataApi, mopFilters, ranDashboard, ranfilters } from '../../../../common/config'
import { MopDatabaseAction } from '../../../../store/actions/dashboardActions'

const RanFilterList = ({setFilterBadge, setfullUrL, setcommonModalState, featureExport,from}) => {
    const dispatch =useDispatch()
    let compOptionArry=[]
    let sowListArry=[]
    let typeOfWorkArry=[]
    let vendorsArry=[]
    let psowArry=[]
    let siteID=[]
    let assignedEngineer=[]
    let dayNightMop=[]
    let sendData=useRef("")
    let filterOptions=useRef([])
    
    let fullURL="fc=True"
    let selectedFilter=[]

    const [fullFilter,setfullFilter]=useState({})
    let handleChange=(dropDown,e)=>{
        // if(e.target.value!=""){
            // if(filterOptions.current.indexOf(e.target.value)==-1){
            //     filterOptions.current.push(e.target.value)
            // }

            fullFilter[dropDown]=e.target.value
            // sendData.current=sendData.current +dropDown+"="+e.target.value+"&"
        console.warn("cknbdbkjreef=",sendData)
    // }
    

    setfullUrL(fullURL)
    featureExport(fullURL)

    console.log(fullFilter,fullURL,"fullFilterfullFilter")
    // fullFilter
    // fullFilter.map((oneFilter)=>{
    //   console.log(oneFilter,"oneFilteroneFilter")  
    // })


    

    }

    const submitData = ()=>{

        let selData=[]
        
        Object.keys(fullFilter).map((oneFilter,index) => {
        
            const value = fullFilter[oneFilter];
            selData.push(value)
            console.log(oneFilter,"oneFilteroneFilter")
            // if(index!=0){
            //     fullURL="?"+oneFilter+"="+value
            // }else{
                fullURL=fullURL+"&"+oneFilter+"="+encodeURIComponent(value)
            // }
            
        })
        selectedFilter=selData.map((item)=>{
            return <p className='badge badge-info'>{item}</p>
        })
        setFilterBadge(selectedFilter)

        let Filleddata=dispatch(LCLranDashboardReducerAction({filterUrl:`${"fc=True&"+fullURL}`}))
        
        dispatch(AccountReducerAction(from + Filleddata,true));
        setcommonModalState(false)
    }

    
    const count =useSelector((state)=>{
        console.log("the state is =", state);
        let filterObj =state.OneCommonResponse.filterDropDown
        console.warn("jxhbkjvbjacvkecfrwgvw=",filterObj)
        if(filterObj && Object.keys(filterObj).length>0){
            
             compOptionArry= filterObj?.companies.sort().map((item,index)=>{
                return <option value={item}>{item}</option>
            })
             sowListArry =filterObj?.serviceAffected.map((item,index)=>{
                return <option value={item}>{item}</option>
            }) 
             typeOfWorkArry =filterObj?.requestForm.map((item,index)=>{
                return <option value={item}>{item}</option>
            })
            psowArry =filterObj?.plannedSow.map((item,index)=>{
                return <option value={item}>{item}</option>
            })  
            vendorsArry =filterObj?.vendors.sort().map((item,index)=>{
               return <option value={item}>{item}</option>
            })  
            siteID =filterObj?.siteIdes.map((item,index)=>{
                return <option value={item}>{item}</option>
            })  
            dayNightMop=filterObj.dayNightMop.map((item,index)=>{
                return <option value={item}>{item}</option>
            })  
            assignedEngineer=filterObj.assignedEngineer.map((item,index)=>{
                if(index==0){
                    return <option disabled selected value={""}>Select</option>
                }
                return <option value={item}>{item}</option>
            })  
        }
        compOptionArry.unshift(<option disabled selected value={""}>Select</option>)
        sowListArry.unshift(<option disabled selected value={""}>Select</option>)
        typeOfWorkArry.unshift(<option disabled selected value={""}>Select</option>)
        vendorsArry.unshift(<option disabled selected value={""}>Select</option>)
        siteID.unshift(<option disabled selected value={""}>Select</option>)
        dayNightMop.unshift(<option disabled selected value={""}>Select</option>)
        assignedEngineer.unshift(<option disabled selected value={""}>Select</option>)
        psowArry.unshift(<option disabled selected value={""}>Select</option>)
        
            let dropDown={
                "siteId":{"label":"Site Name","values":siteID ,"dType":"S"},
                "crewDataResult.crewLeadCompanyId":{"label":"Crew Company","values":compOptionArry,"dType":"S"},
                "crewDataResult.vendorId":{"label":"Crew Vendor","values":vendorsArry,"dType":"S"},
                "serviceAffected":{"label":"Service Affected","values":sowListArry},
                "requestForm":{"label":"Requested From","values":typeOfWorkArry},
                "plannedSow":{"label":"Planned SOW","values":psowArry},
                "dayNightMop":{"label":"Day Night MOP","values":dayNightMop},
                "assignedEngineer":{"label":"Assigned Engineer","values":assignedEngineer ,"dType":"S"}
            }
            
            let dropdownSkel=Object.keys(dropDown).map((item,index)=>{
                
                // console.warn(",mdscbvbcvwchkuvcwsvr=",dropDown.item)
                console.warn(",mdscbvbcvwchkuvcwsvr=", dropDown[item]["values"])

                if(dropDown[item]['dType']=="S"){
                    return(
                        <div className='form-group col-3'> 
                            <label>{dropDown[item]["label"]}</label>
                            <input className='form-control' onChange={(e)=>handleChange(item,e)} list={index}
                                style={{ height: "32px" }}/>
                                <datalist id={index}>

                                {dropDown[item]["values"]}
                                </datalist>

                        </div>
                    )
                }
                else if(dropDown[item]['dType']=="M"){

                }


                else{
                    return(
                    <div className='form-group col-3'>
                        <label>{dropDown[item]["label"]}</label>
                        <select className='form-control' 
                        
                        onChange={(e)=>handleChange(item,e)}
                        >
                            {
                            dropDown[item]["values"]
                            }
                        </select>
                    </div>
                    )
                        }
            })
    
        return({filterObj,dropDown,dropdownSkel})
    })    


    useEffect(()=>{
        
        // dispatch(getFilterDropDown([]))
        // dispatch(AccountReducerAction(ranfilters))

    },[])
  return (
    <>
        <div className='row'>
            {count.dropdownSkel}

            {console.log(count.dropdownSkel,"count.dropdownSkel")}

        </div>

        <button onClick={(e)=>{
            submitData()
        }} className={'btn btn-xs btn-primary mx-2 py-2 btn btn-primary'}>SEARCH</button>
    </>
  )
}

export default RanFilterList